import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac57e2a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel" }

import { computed, nextTick, onBeforeUnmount, onMounted, ref, toRef, watch } from "vue";
import { useI18n } from "vue-i18n";
import config from "@/config";
import { menuModule } from "@/store";
import MobileMenuDrawer from "./components/MobileMenuDrawer/index.vue";
import MobileMenuNav from "./components/MobileMenuNav/index.vue";
import MobileMenuActions from "./components/MobileMenuActions/index.vue";
import MobileMenuViewButton from "./components/MobileMenuViewButton/index.vue";
import type { MobileMenuItem } from "./types";


export default /*#__PURE__*/_defineComponent({
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: "close"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isOpen: boolean }




const { t } = useI18n();
const isOpen = toRef(props, "isOpen");
const closeButton = ref<InstanceType<typeof MobileMenuViewButton> | null>(null);
const drawerComponent = ref<InstanceType<typeof MobileMenuDrawer> | null>(null);
const drawer = computed(() => drawerComponent.value?.drawer ?? null);

const isExternalLink = (link: string): boolean => /^https?:\/\//i.test(link);

const resolveHref = (item: any): string => {
  if (item.external || isExternalLink(item.link) || item.link === "#") {
    return item.link;
  }

  return config.base + item.link.replace(/^\/+/, "");
};

const resolveMenuItem = (item: any): MobileMenuItem => ({
  name: item.name,
  title: item.title ?? item.name,
  route: item.link,
  href: resolveHref(item),
  external: Boolean(item.external) || isExternalLink(item.link),
  children: (item.child ?? []).map(resolveMenuItem),
});

const menuItems = computed<MobileMenuItem[]>(() =>
  menuModule.getMenu.map(resolveMenuItem)
);

const requestClose = (): void => emit("close");

const focusableElements = (): HTMLElement[] => {
  if (!drawer.value) return [];

  return Array.from(
    drawer.value.querySelectorAll<HTMLElement>(
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )
  ).filter((element) => element.offsetParent !== null);
};

const handleKeydown = (event: KeyboardEvent): void => {
  if (!isOpen.value) return;

  if (event.key === "Escape") {
    event.preventDefault();
    requestClose();
    return;
  }

  if (event.key !== "Tab") return;

  const focusable = focusableElements();
  if (!focusable.length) return;

  const first = focusable[0];
  const last = focusable[focusable.length - 1];

  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
};

watch(
  isOpen,
  (open) => {
    document.body.classList.toggle("no-scroll", open);

    if (open) {
      void nextTick(() => closeButton.value?.button?.focus());
    }
  },
  { immediate: true }
);

onMounted(() => {
  menuModule.Load();
});

onBeforeUnmount(() => {
  document.body.classList.remove("no-scroll");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MobileMenuDrawer, {
    ref_key: "drawerComponent",
    ref: drawerComponent,
    "is-open": _unref(isOpen),
    "aria-label": _unref(t)('mobile_menu.navigation'),
    "close-label": _unref(t)('mobile_menu.close'),
    onClose: requestClose,
    onKeydown: handleKeydown
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createVNode(MobileMenuViewButton, {
          ref_key: "closeButton",
          ref: closeButton,
          label: _unref(t)('mobile_menu.close'),
          onClick: requestClose
        }, null, 8, ["label"]),
        _createVNode(MobileMenuNav, {
          items: _unref(menuItems),
          label: _unref(t)('mobile_menu.navigation'),
          onNavigate: requestClose
        }, null, 8, ["items", "label"]),
        _createVNode(MobileMenuActions, {
          "shopping-cart-label": _unref(t)('mobile_menu.shopping_cart'),
          onNavigate: requestClose
        }, null, 8, ["shopping-cart-label"])
      ])
    ]),
    _: 1
  }, 8, ["is-open", "aria-label", "close-label"]))
}
}

})